module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-sub-event",
    attrs: {
      "id": "section-sub-event",
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('page-subheader', {
    attrs: {
      "title": _vm.paragraph.title
    }
  }), _vm._v(" "), _c('div-container', [(_vm.imageUrl) ? _c('div', {
    staticClass: "columns is-gapless is-centered"
  }, [_c('div', {
    staticClass: "column is-3 has-text-centered content content-image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "padding": "30px"
    },
    attrs: {
      "src": _vm.imageUrl,
      "width": "200"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-8 has-text-left content",
    class: {
      'with-image': _vm.imageUrl !== undefined
    },
    domProps: {
      "innerHTML": _vm._s(_vm.paragraph.content)
    }
  })]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d307688","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/EventSubSection.vue
// module id = 919
// module chunks = 1